import React, { Component } from "react";

import Registry from "../Utils/Registry";
import Helpers from "../Utils/Helpers";


class TYCookiesMsg extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.cookiesAccepted = this.cookiesAccepted.bind(this);

        this.state = {
            isShown: !this.api.webStorage.getItem("cookies_msg_accepted")
        };
    }

    cookiesAccepted(){
        this.api.webStorage.setItem("cookies_msg_accepted", true);
        this.setState({isShown: false});
    }

    render(){
        return (
            this.state.isShown ?
                <div className="fixed text-white bottom-0 wp-100 pad-0 bg-blue_dark" style={{zIndex: "10000"}} id="cookies_msg">
                    <div className="center text-white f-10 pad-10">
                        En continuant votre navigation sur ce site, vous acceptez l’utilisation des cookies afin
                        d’assurer le bon d&eacute;roulement de votre visite et de r&eacute;aliser des statistiques d’audience.&nbsp;
                        <span className="blue underline pointer"
                            onClick={() => Helpers.goToNewTab("https://www.microsoft.com/fr-fr/security/resources/cookie-whatis.aspx")}
                        >
                            En savoir plus
                        </span>
                        <span className="pad-10 pointer" onClick={this.cookiesAccepted}>
                            <i className="icon-cross" aria-hidden="true"> </i>
                        </span>
                    </div>
                </div>
                : null
        );
    }
}

TYCookiesMsg.defaultProps = {

};

export default TYCookiesMsg;



// WEBPACK FOOTER //
// ./src/components/TYCookiesMsg.js